import * as React from "react";
import _ from "lodash";

import { Button } from "src/library/components/Button";
import LikeToDo from "src/library/components/LikeToDo/LikeToDo";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { PageProps } from "src/pages/Router/routes";
import useCheckUserPermission from "src/core/users/hooks/useCheckUserPermission";
import {
  TabbedNavigation,
  TabOptions
} from "src/library/components/TabbedNavigation";

import NotificationsTab from "./NotificationsTab";

/**
 * Main "Notifications" View
 *
 * @returns
 */
const NotificationsManagementPage: React.ReactFCWithChildren<PageProps<unknown>> = props => {
  const { terminology } = props;
  const checkPermission = useCheckUserPermission();
  const canCreateNotification = checkPermission("create-notification");

  const CreateNewNotification = React.useMemo(() => (
    <Button onClick={() => props.history.push("/platform/notifications/create")}>
      {`Send a new ${terminology.notification.singular.text}`}
    </Button>
  ), [ props.history, terminology ]);

  const tabs: TabOptions[] = React.useMemo(() => {
    return [
      {
        title: "Manual Notifications",
        name: "manualNotifications",
        content: () => (
          <NotificationsTab
            terminology={terminology}
            notificationType="manual"
          />
        )
      },
      {
        title: "System Notifications",
        name: "systemNotifications",
        content: () => (
          <NotificationsTab
            terminology={terminology}
            notificationType="system"
          />
        )
      }
    ];
  }, [ terminology ]);

  return (
    <Layout {...props}>
      <MainContentWrapper
        fill
        Header={canCreateNotification && (
          <LikeToDo
            copy="What would you like to do?"
            buttons={[ CreateNewNotification ]}
          />
        )}
      >

        <TabbedNavigation tabs={tabs} />
      </MainContentWrapper>

    </Layout>
  );
};

export default NotificationsManagementPage;